import { API } from "./api";
import { logDebug } from "./log";

function uuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getVisitorId() {
  let id = localStorage.getItem("aka_visitor");
  if (!id) {
    id = uuid();
    localStorage.setItem("aka_visitor", id);
  }
  return id;
}

function send(body) {
  try {
    const blob = new Blob([JSON.stringify(body)], { type: "application/json" });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/analytics/track`, blob);
      return;
    }
  } catch (e) {
    logDebug("sendBeacon unavailable, using fetch fallback", e);
  }
  fetch(`${API}/analytics/track`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    keepalive: true,
  }).catch(() => {});
}

export function trackPageview(path = "/") {
  send({ event: "pageview", visitor_id: getVisitorId(), path });
}

export function trackClick(platform) {
  send({ event: "click", visitor_id: getVisitorId(), platform });
}
